<template>
  <v-dialog max-width="800" :model-value="isVisible">
    <v-card>
      <v-card-title class="d-flex flex-row ma-4">
        <h4>
          <span>Where this form is displayed</span>
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          icon="mdi-close"
          variant="text"
          density="comfortable"
          @click="$emit('close')"></v-btn>
      </v-card-title>
      <v-card-text class="d-flex flex-column gap-4">
        <v-carousel
          v-model="selectedImage"
          hide-delimiters
          class="rounded-lg border"
          :show-arrows="images.length > 1">
          <div class="text-center typography-body-md-bold my-2">
            <template v-if="app === 'all'">
              <span v-if="selectedImage === 0">1. {{ getCaption('warehouse') }}</span>
              <span v-if="selectedImage === 1">2. {{ getCaption('carrier') }}</span>
            </template>
            <template v-else>
              <span>{{ getCaption(app) }}</span>
            </template>
          </div>
          <v-carousel-item v-for="image in images" :key="image" :src="`/images/${image}`" />
        </v-carousel>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-btn variant="outlined" @click="$emit('close')">Got it</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  emits: ['close'],
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    app: {
      type: String,
      required: true,
      validator: value => ['warehouse', 'carrier', 'driver', 'api', 'all'].includes(value)
    }
  },
  setup(props) {
    const selectedImage = ref('');

    const images = computed(() => {
      if (props.app === 'all') {
        return ['custom-forms-preview-warehouse.png', 'custom-forms-preview-carrier.png'];
      }

      if (props.app === 'carrier') {
        return ['custom-forms-preview-carrier.png'];
      }

      return ['custom-forms-preview-warehouse.png'];
    });

    const getCaption = app => {
      if (app === 'carrier') {
        return 'When the carrier is creating an appointment';
      }

      if (app === 'driver') {
        return 'When the driver is performing the check in through the check in app';
      }

      if (app === 'warehouse') {
        return 'When the warehouse is creating an appointment';
      }
    };

    return {
      getCaption,
      images,
      selectedImage
    };
  }
});
</script>
